import type { SxProps, Theme } from '@mui/material'
import { lighten } from '@mui/material/styles'

/** Icon-button treatment for the arrows on horizontal scrollable tabs. */
export const horizontalScrollableTabsSx: SxProps<Theme> = (theme) => ({
    '& .MuiTabs-scrollButtons': {
        width: 32,
        height: 32,
        margin: 'auto 2px',
        borderRadius: '50%',
        color: theme.palette.text.primary,
        backgroundColor: lighten(theme.palette.primary.light, 0.9),
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shortest,
        }),
        '&:hover, &.Mui-focusVisible': {
            backgroundColor: lighten(theme.palette.primary.light, 0.8),
        },
        '& svg': {
            fontSize: '1.5rem',
        },
    },
})
